import type { userType } from '@/types/common';

export interface IAuth {
  data: userType | null;
  isAuth(): boolean;
}

export default class Auth implements IAuth {
  data: userType | null = null;

  constructor(user: userType | null) {
    this.data = user;
  }

  setUser(user: userType | null) {
    this.data = user;
  }

  isAuth(): boolean {
    if (this.data?.id) {
      return true;
    }
    return false;
  }
}
